/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_lower.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns a new string representing the input string converted to lower case.
 *
 * @example
 * ROW message = "Some Text"
 * | EVAL message_lower = TO_LOWER(message)
 *
 * @example
 * ROW v = TO_LOWER(["Some", "Text"])
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'to_lower',
  signatures: [
    {
      params: [
        {
          name: 'str',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'str',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
